import { FC } from 'react';

import { Connect } from '@rover/react-lib/src/components/utils/Redux';
import NarrowDeviceSearchBox from '@rover/react-lib/src/pages/index/HomePage/components/IntuitiveOwnerWizard/NarrowDeviceSearchBox';
import {
  actions as searchBoxActions,
  selectors as searchBoxSelectors,
} from '@rover/react-lib/src/pages/index/HomePage/components/SearchBox/SearchBox.duck';

export interface NarrowDeviceSearchBoxContainerProps {
  isAuthenticated: boolean;
}

const actions = {
  updateFilters: searchBoxActions.updateFilters,
};

const selector = (state) => ({
  filters: searchBoxSelectors.getFilters(state),
  serviceType: searchBoxSelectors.getServiceType(state),
  serviceTypeOptions: searchBoxSelectors.getPetTypeServiceTypeOptions(state),
});

const NarrowDeviceSearchBoxContainer: FC<NarrowDeviceSearchBoxContainerProps> = (props) => {
  return (
    <Connect actions={actions} selector={selector}>
      {(connectedProps) => <NarrowDeviceSearchBox {...connectedProps} {...props} />}
    </Connect>
  );
};

export default NarrowDeviceSearchBoxContainer;
